import React from 'react';
import OriginalSearchBar from '@theme-original/SearchBar';
import {useColorMode} from '@docusaurus/theme-common';
import {FiHome, FiMoon, FiSun} from 'react-icons/fi';

export default function SearchBarWrapper(props) {
  const {colorMode, setColorMode} = useColorMode();
  const toggle = () => setColorMode(prev => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <div className="custom-navbar-actions">
      <a
        className="custom-navbar-action clean-btn"
        href="https://igrant.io"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="iGrant.io home"
        title="iGrant.io Landing Page"
      >
        <FiHome className="custom-navbar-action-icon" />
      </a>
      <button
        type="button"
        className="custom-navbar-action clean-btn"
        onClick={toggle}
        aria-label="Toggle color mode"
        title={`Switch between dark and light mode(currently ${colorMode})`}
      >
        {colorMode !== 'dark' ? (
          <FiSun className="custom-navbar-action-icon" />
        ) : (
          <FiMoon className="custom-navbar-action-icon" />
        )}
      </button>
<OriginalSearchBar {...props} />
    </div>
  );
}
